import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    resendUserInvitesBulkAction: builder.mutation<
      void,
      {
        accountId: string;
        accountUserIds: string[];
      }
    >({
      query: ({ accountId, accountUserIds }) => ({
        url: `v4/accounts/users/invites/resend:bulk`,
        method: 'POST',
        body: { accountNumber: accountId, userIds: accountUserIds },
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useResendUserInvitesBulkActionMutation } = apiSlice;
